// src/IframePage.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  isMobile,
  isTablet,
  isSmartTV,
  isBrowser,
} from 'react-device-detect';
import BottomNav from './BottomNav';
import TopBarYou from './TopBarYou';
import SidebarYou from './SidebarYou';

const IframePage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const url = params.get('url');

  if (!url) return <div className="p-4">URL inválida ou ausente.</div>;

  return (
    <div className="dashboard-you min-h-screen dark-mode">
      {!(isMobile || isTablet) && <TopBarYou />}
      {(isBrowser || isSmartTV) && <SidebarYou />}

      <div
        className="dashboard-content"
        style={{
          paddingTop: !(isMobile || isTablet) ? '70px' : '0px',
          marginLeft: isBrowser || isSmartTV ? '65px' : '0',
          transition: 'margin-left 0.3s ease',
          height: 'calc(100vh - 70px)',
        }}
      >
        <iframe
          src={url}
          title="Conteúdo Externo"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
          }}
        />
      </div>

      {(isMobile || isTablet) && <BottomNav />}
    </div>
  );
};

export default IframePage;
